import ClientTabs from './ClientTabs';

export default ClientTabs;